export const RESULTS_URL =
  'https://s3-us-west-2.amazonaws.com/caltimes-la-county-elections-scraper-dev/lacounty-municipal-special-elections-20190604/latest.json';

export const STATIC_RESULTS_URL = 'static/snapshot.json';

export const RACE_MAPPING = {
  '001': 'sd-33',
  '002': 'arcadia-measure-a',
  '003': 'compton-cd-1',
  '004': 'compton-cd-4',
  '005': 'la-cd-12',
  '006': 'measure-ee',
};

export const NAME_MAPPING = {
  'JACK M GUERRERO': {
    first: 'Jack',
    last: 'Guerrero',
    slug: 'jack-guerrero',
  },
  'LENA GONZALEZ': {
    first: 'Lena',
    last: 'Gonzalez',
    slug: 'lena-gonzalez',
  },
  'MICHELLE CHAMBERS': {
    first: 'Michelle',
    last: 'Chambers',
    slug: 'michelle-chambers',
  },
  'JANNA ZURITA': {
    first: 'Janna',
    last: 'Zurita',
    slug: 'janna-zurita',
  },
  'EMMA SHARIF': {
    first: 'Emma',
    last: 'Sharif',
    slug: 'emma-sharif',
  },
  'JUSTIN A BLAKELY': {
    first: 'Justin',
    last: 'Blakely',
    slug: 'justin-blakely',
  },
  'JEFF DAAR': {
    first: 'Jeff',
    last: 'Daar',
    slug: 'jeff-daar',
  },
  'CHARLES SEAN DINSE': {
    first: 'Sean',
    last: 'Dinse',
    slug: 'sean-dinse',
  },
  'JACK KAYAJIAN': {
    first: 'Jack',
    last: 'Kayajian',
    slug: 'jack-kayajian',
  },
  'JOSH YEAGER': {
    first: 'Josh',
    last: 'Yeager',
    slug: 'josh-yeager',
  },
  'FRANK FERRY': {
    first: 'Frank',
    last: 'Ferry',
    slug: 'frank-ferry',
  },
  'BRANDON SAARIO': {
    first: 'Brandon',
    last: 'Saario',
    slug: 'brandon-saario',
  },
  'NAVRAJ SINGH': {
    first: 'Navraj',
    last: 'Singh',
    slug: 'navraj-singh',
  },
  'ANNIE EUNWOO CHO': {
    first: 'Annie',
    last: 'Cho',
    slug: 'annie-cho',
  },
  'CARLOS AMADOR': {
    first: 'Carlos',
    last: 'Amador',
    slug: 'carlos-amador',
  },
  'SCOTT ABRAMS': {
    first: 'Scott',
    last: 'Abrams',
    slug: 'scott-abrams',
  },
  'RAJI RAB': {
    first: 'Raji',
    last: 'Rab',
    slug: 'raji-rab',
  },
  'JOHN LEE': {
    first: 'John',
    last: 'Lee',
    slug: 'john-lee',
  },
  'LORAINE LUNDQUIST': {
    first: 'Loraine',
    last: 'Lundquist',
    slug: 'loraine-lundquist',
  },
  'STELLA T MALOYAN': {
    first: 'Stella',
    last: 'Maloyan',
    slug: 'stella-maloyan',
  },
  'JAY BEEBER': {
    first: 'Jay',
    last: 'Beeber',
    slug: 'jay-beeber',
  },
  YES: {
    name: 'Yes',
    slug: 'yes',
  },
  NO: {
    name: 'No',
    slug: 'no',
  },
};
